import * as React from "react";
import { observer } from "mobx-react";
import { LOBState, CarWizardState, HotelWizardState, LxWizardState } from "src/stores/wizard/state";
import { UitkTextInput } from "uitk-react-input";
import { LocationType } from "./LocationType";
import { formatText } from "bernie-l10n";
import { Result, listResult } from "./LocationList";
import { PackagesSubLobs } from "src/stores/wizard/state/typings";

export interface DefaultLocationProps {
  lobState: LOBState;
  defaultLocation: string;
  locationConfig: any;
  locationType: LocationType;
  name: string;
  biasedStopover?: string;
}

const noop = () => {
  return null;
};

export const DefaultLocation = observer(
  ({ lobState, defaultLocation, locationType, locationConfig, name, biasedStopover }: DefaultLocationProps) => {
    const locationState = lobState.location;
    const { DESTINATION } = LocationType;

    const defaultLocationArray = defaultLocation.split(":");
    const setDefaultLocationAndGetValue = () => {
      if (biasedStopover) {
        return biasedStopover;
      }
      locationState[locationType].value = defaultLocationArray[0];

      return locationState[locationType].value;
    };

    const value = setDefaultLocationAndGetValue();

    //label selection
    const isCarWizardState = lobState instanceof CarWizardState;
    const destinationValue =
      locationState.destination.value === locationState.origin.value && isCarWizardState
        ? ""
        : locationState.destination.value;

    const getDestinationLabelToken = () => {
      const { withValueLabelToken, noValueLabelToken, labelToken } = locationConfig.destination;

      return lobState instanceof CarWizardState && lobState.isDesktop
        ? destinationValue
          ? withValueLabelToken
          : noValueLabelToken
        : labelToken;
    };

    const locationLabelToken =
      locationType === DESTINATION ? getDestinationLabelToken() : locationConfig.origin.labelToken;

    const { multiHotelIDs } = lobState.config;
    const isHotelInstance = lobState instanceof HotelWizardState;
    const isPackageInstance =
      lobState.subLOBState === PackagesSubLobs.HOTEL_CAR ||
      lobState.subLOBState === PackagesSubLobs.FLIGHT_HOTEL ||
      lobState.subLOBState === PackagesSubLobs.FLIGHT_HOTEL_CAR;
    const isHotelPackageInstance = isPackageInstance || isHotelInstance;
    const hasMultiHotelIds = isHotelPackageInstance && multiHotelIDs;
    const hotelIdResult: Result[] = hasMultiHotelIds ? listResult(multiHotelIDs, "|") : [];
    const groupValue = hotelIdResult.find(({ key }) =>
      key.toLowerCase().includes(locationState.destination.value.toLowerCase())
    );
    const isLXInstance = lobState instanceof LxWizardState;

    return (
      <div>
        <UitkTextInput
          data-testid="default-location-input"
          label={formatText(locationLabelToken)}
          name={isLXInstance ? "location" : name}
          value={value}
          onChange={noop}
        />
        <input
          type="hidden"
          data-testid="default-location-hidden-input"
          name={isLXInstance ? "rid" : "regionId"}
          value={defaultLocationArray && defaultLocationArray[1]}
        />
        {hasMultiHotelIds && <input type="hidden" name="group" value={groupValue?.value} />}
      </div>
    );
  }
);
